// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import retailerReducer from "./retailerSlice";

const store = configureStore({
  reducer: {
    retailer: retailerReducer,
  },
});

export default store;
